module.exports = __webpack_public_path__ + "img/orgTree.02064c56.svg";